


































import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class LoadingDialog extends Vue {
  @Prop({ default: false }) isDialogOpen: boolean;
  @Prop({ default: false }) isLoading: boolean;
  @Prop({ default: false }) hasLoadingFailed: boolean;
  @Prop({ default: false }) hasRetryFailed: boolean;
  @Prop({ default: 'Envoi en cours' }) title: string;
  @Prop({ default: 'L\'envoi des informations est en cours\nVeuillez patienter...' }) loadingText: string;
  @Prop({ default: 'L\'envoi des informations a échoué\nVeuillez cliquer sur "{button}"' }) retryText: string;
  @Prop({ default: 'L\'envoi des informations a échoué' }) failedText: string;
  @Prop({ default: 'Réessayer' }) retryButtonText: string;
  @Prop({ default: 'OK' }) closeButtonText: string;

  get computedRetryText(): string {
    return this.retryText.replace(
      '{button}',
      this.retryButtonText
    );
  }

  get displayLoadingView(): boolean {
    return this.isLoading;
  }

  get displayRetryView(): boolean {
    return this.hasLoadingFailed && !this.isLoading && !this.hasRetryFailed;
  }

  get displayErrorView(): boolean {
    return this.hasRetryFailed;
  }

  retry() {
    this.$emit('retry');
  }

  close() {
    this.$emit('close');
  }
}
